import { render, staticRenderFns } from "./jira_actions.vue?vue&type=template&id=215ca556&scoped=true&"
import script from "./jira_actions.vue?vue&type=script&lang=js&"
export * from "./jira_actions.vue?vue&type=script&lang=js&"
import style0 from "./jira_actions.vue?vue&type=style&index=0&id=215ca556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ca556",
  null
  
)

export default component.exports